import { render, staticRenderFns } from "./RamanScatteringViz.vue?vue&type=template&id=90cc3760&scoped=true"
import script from "./RamanScatteringViz.vue?vue&type=script&lang=js"
export * from "./RamanScatteringViz.vue?vue&type=script&lang=js"
import style0 from "./RamanScatteringViz.vue?vue&type=style&index=0&id=90cc3760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cc3760",
  null
  
)

export default component.exports